
//src/assets/scripts/top/page.js
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import Swiper from 'swiper';

import { Autoplay,Parallax,Scrollbar, Mousewheel, Navigation, Pagination, EffectFade } from "swiper/modules";


gsap.registerPlugin(ScrollTrigger);



export default class PageJS {
    constructor(common) {
        this.common = common;
    }

    init() {
        this._secMvSwiper();
        this._btnStyle();
        this._secFeatures();
        this._secExperience();
        this._imgPararax();
        this._secView();
        //this._bodyMode();


        this.common.init();//common.jsはここでinitさせる
    }

    _secMvSwiper() {
        const el = document.querySelector("#Mv_area .mv_swiper");
        if (!el) return;
        new Swiper(el, {
            modules: [Autoplay, Parallax],
            loop: true, // ループ
            parallax: true, // パララックス
            allowTouchMove: false, // マウスでのスワイプ禁止
            speed: 1000, // 速度
            slidesPerView: 1,
            autoplay: {
                //reverseDirection: true, // 逆再生
                reverseDirection: false, // 逆再生
                delay: 3000, // 3秒遅らせる
            },
        });
    }

    _btnStyle() {
        const mm = gsap.matchMedia();
        // PC
        mm.add("(min-width: 738px)", () => {

            document.querySelectorAll(".btn_anm_trigger").forEach((btn) => {
            //document.querySelectorAll(".btn_style a").forEach((btn) => {
                const arrowWrap = btn.querySelector(".arrow");
                const a1 = btn.querySelector(".arrow1");
                const a2 = btn.querySelector(".arrow2");
                if (!arrowWrap || !a1 || !a2) return;

                const onEnter = () => {
                    gsap.to(arrowWrap, { scale: 1.05, duration: 0.25, overwrite: true });

                    // 1枚目：右上に抜ける（= 右へ、上へ）
                    gsap.to(a1, {
                        "--ax": "120%",
                        "--ay": "-200%",
                        duration: 0.35,
                        overwrite: true,
                    });

                    // 2枚目：左下から中央へ（待機 → 中央）
                    gsap.to(a2, {
                        "--ax": "-50%",
                        "--ay": "-50%",
                        duration: 0.35,
                        delay: 0.12,
                        overwrite: true,
                    });
                };

                const onLeave = () => {
                    gsap.to(arrowWrap, { scale: 1, duration: 0.25, overwrite: true });

                    // 戻す：1枚目を中央へ
                    gsap.to(a1, {
                        "--ax": "-50%",
                        "--ay": "-50%",
                        duration: 0.25,
                        overwrite: true,
                    });

                    // 2枚目を左下待機へ
                    gsap.to(a2, {
                        "--ax": "-200%",
                        "--ay": "100%",
                        duration: 0.25,
                        overwrite: true,
                    });
                };

                btn.addEventListener("mouseenter", onEnter);
                btn.addEventListener("mouseleave", onLeave);
            });
        });
    }


    _secFeatures() {
        const mm = gsap.matchMedia();

        mm.add("(min-width: 738px)", () => {
            const section = document.querySelector("#Features_area");
            const track = section?.querySelector(".content_area_wrap");

            if (!section || !track) return;

            ScrollTrigger.getById("featuresHorizontal")?.kill();

            const getDistance = () => {
                const dist = track.scrollWidth - section.clientWidth;
                return Math.max(0, dist);
            };

            gsap.set(track, { x: 0 });

            const featuresTween = gsap.to(track, {
                x: () => -getDistance(),
                ease: "none",
                scrollTrigger: {
                    id: "featuresHorizontal",
                    trigger: section,
                    pin: true,
                    scrub: true,
                    start: "top top",
                    end: () => `+=${getDistance()}`,
                    invalidateOnRefresh: true,
                    anticipatePin: 1,
                    // markers: true,
                    toggleClass: {
                        targets: document.body,
                        className: "litemode"
                    },
                },
            });

            // 横スクロール内の[data-secview]だけ右→左で発火
            this._secView(featuresTween, section);
            this._imgPararax(featuresTween);

            return () => {
                featuresTween.scrollTrigger?.kill();
                featuresTween.kill();
            };
        });

        mm.add("(max-width: 737px)", () => {
            const section = document.querySelector("#Features_area");
            if (!section) return;
            
            ScrollTrigger.create({
                trigger: section,
                start: "top 50%",
                end: "top 90%",
                endTrigger: "#Experience_area",
                toggleClass: {
                    targets: document.body,
                    className: "litemode"
                },
                //markers: true,
            });


        });

    }
    _secExperience() {

        // ▼ matchMedia
        let mm = gsap.matchMedia();

        //PC
        mm.add("(min-width: 738px)", () => {

            const experTl_01 = gsap.timeline({
                scrollTrigger: {
                    trigger: "#Experience_area .contents01",
                    start: "top top",
                    //end: () => "+=" + endHeight,
                    end: () => "+=" + (window.innerHeight * 4),
                    pin: true,
                    //markers: true,
                    scrub: true,
                    
                },
            });

            experTl_01
                .to("#Experience_area .contents01 .img_area .box1", {
                    duration: 1.2,
                    clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
                    ease: "power1.inOut",
                })
                .to("#Experience_area .contents01 .img_area .box2", {
                    duration: 1,
                    clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
                    ease: "power1.inOut",
                })
                .to("#Experience_area .contents01 .txt_area .box1", {
                    duration: 0.5,
                    opacity: 0,
                }, "-=0.8")
                .to("#Experience_area .contents01 .txt_area .box2", {
                    duration: 1,
                    opacity: 1,
                    zIndex: 30,
                }, "-=0.8")
                .to("#Experience_area .contents01 .img_area .box3", {
                    duration: 1,
                    clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
                    ease: "power1.inOut",
                })
                .to("#Experience_area .contents01 .txt_area .box2", {
                    duration: 0.5,
                    opacity: 0,
                }, "-=0.8")
                .to("#Experience_area .contents01 .txt_area .box3", {
                    duration: 1,
                    opacity: 1,
                    zIndex: 40,
                }, "-=0.8")
                .to("#Experience_area .contents01 .img_area .box4", {
                    duration: 1,
                    clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
                    ease: "power1.inOut",
                })
                .to("#Experience_area .contents01 .txt_area .box3", {
                    duration: 0.5,
                    opacity: 0,
                }, "-=0.8")
                .to("#Experience_area .contents01 .txt_area .box4", {
                    duration: 1,
                    opacity: 1,
                    zIndex: 50,
                }, "-=0.8")
                ;
        const experTl_02 = gsap.timeline({
            scrollTrigger: {
                trigger: "#Experience_area .contents02",
                start: "top top",
                end: () => "+=" + (window.innerHeight * 4),
                pin: true,
                //markers: true,
                scrub: true,

            },
        });

        experTl_02
            .to("#Experience_area .contents02 .img_area .box1", {
                duration: 1.2,
                clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
                ease: "power1.inOut",
            })
            .to("#Experience_area .contents02 .img_area .box2", {
                duration: 1,
                clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
                ease: "power1.inOut",
            })
            .to("#Experience_area .contents02 .img_area .box3", {
                duration: 1,
                clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
                ease: "power1.inOut",
            })
            .to("#Experience_area .contents02 .img_area .box4", {
                duration: 1,
                clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
                ease: "power1.inOut",
            })
            ;
        });

    }
    
    _imgPararax(containerTween = null) {
        const mm = gsap.matchMedia();

        const setup = (strengthDefault) => {
            const BREAK_SP = 738; 
            const isSP = window.matchMedia(`(max-width: ${BREAK_SP - 1}px)`).matches;

            const all = gsap.utils.toArray("[data-parallax]");
            const targets = containerTween
                ? all.filter((el) => el.closest("#Features_area"))
                : all.filter((el) => {
                    // PC時だけ Features を通常処理から除外
                    if (!isSP && el.closest("#Features_area")) return false;
                    return true;
                });

            if (!targets.length) return;

            const tweens = [];

            targets.forEach((el) => {
                const trigger =
                    el.closest("li, .parallax_wrap, .img_area, section") || el;

                const strength = parseFloat(
                    el.getAttribute("data-parallax-strength") || String(strengthDefault)
                );

                if (el.tagName === "IMG" && !el.complete) {
                    el.addEventListener("load", () => ScrollTrigger.refresh(), { once: true });
                }

                gsap.set(el, { willChange: "transform" });

                const isHorizontal = !!containerTween;

                const stOptions = {
                    trigger,
                    scrub: true,
                    invalidateOnRefresh: true,
                };

                if (isHorizontal) {
                    stOptions.containerAnimation = containerTween;
                    stOptions.start = "left right";
                    stOptions.end = "right left";
                } else {
                    stOptions.start = "top bottom";
                    stOptions.end = "bottom top";
                }

                const fromVars = isHorizontal ? { x: strength } : { y: strength };
                const toVars = isHorizontal
                    ? {
                        x: -strength,
                        ease: "none",
                        scrollTrigger: stOptions,
                    }
                    : {
                        y: -strength,
                        ease: "none",
                        scrollTrigger: stOptions,
                    };

                const tween = gsap.fromTo(el, fromVars, toVars);
                tweens.push(tween);
            });

            return () => {
                tweens.forEach((t) => {
                    t.scrollTrigger?.kill();
                    t.kill();
                });
            };
        };

        mm.add("(min-width: 768px)", () => setup(60));
    }

    _secView(containerTween = null, scope = document) {
        const BREAK_SP = 738;
        const isSP = window.matchMedia(`(max-width: ${BREAK_SP - 1}px)`).matches;

        const allTargets = scope.querySelectorAll("[data-secview]");
        const targets = containerTween
            ? allTargets
            : [...allTargets].filter((el) => {
                // PC時だけ Features を通常処理から除外
                if (!isSP && el.closest("#Features_area")) return false;
                return true;
            });

        if (!targets.length) return;

        if (!window.__SECVIEW_REFRESH_SCHEDULE__) {
            window.__SECVIEW_REFRESH_SCHEDULE__ = () => {
                if (window.__SECVIEW_REFRESH_QUEUED__) return;
                window.__SECVIEW_REFRESH_QUEUED__ = true;

                requestAnimationFrame(() => {
                    window.__SECVIEW_REFRESH_QUEUED__ = false;
                    ScrollTrigger.refresh();
                });
            };
        }

        targets.forEach((el, idx) => {
            if (el.dataset.secviewSpOnly !== undefined && !isSP) return;
            if (el.dataset.secviewPcOnly !== undefined && isSP) return;

            const ds = el.dataset;

            const pick = (suffix, fallback) => {
                const spKey = `secviewSp${suffix}`;
                const pcKey = `secviewPc${suffix}`;
                const commonKey = `secview${suffix}`;

                if (isSP && ds[spKey] != null && ds[spKey] !== "") return ds[spKey];
                if (!isSP && ds[pcKey] != null && ds[pcKey] !== "") return ds[pcKey];
                if (ds[commonKey] != null && ds[commonKey] !== "") return ds[commonKey];
                return fallback;
            };

            const toNum = (v, fallback) => {
                const n = parseFloat(v);
                return Number.isFinite(n) ? n : fallback;
            };

            const toBool = (v, fallback) => {
                if (v == null || v === "") return fallback;
                return v === "true" || v === "1" || v === "yes";
            };

            const DEFAULT_START = containerTween ? "left 85%" : "top 85%";
            const DEFAULT_DURATION = 0.9;
            const DEFAULT_DELAY = 0;
            const DEFAULT_EASE = "power3.out";
            const DEFAULT_ONCE = true;
            const DEFAULT_BLUR = "12px";
            const DEFAULT_Y_FROM = "16%";
            const DEFAULT_X_FROM = "16%";

            const start = pick("Start", DEFAULT_START);
            const duration = toNum(pick("Duration", DEFAULT_DURATION), DEFAULT_DURATION);
            const delay = toNum(pick("Delay", DEFAULT_DELAY), DEFAULT_DELAY);
            const ease = pick("Ease", DEFAULT_EASE);
            const once = toBool(pick("Once", DEFAULT_ONCE ? "true" : "false"), DEFAULT_ONCE);
            const blurFrom = pick("Blur", DEFAULT_BLUR);
            const yFrom = pick("Y", DEFAULT_Y_FROM);
            const xFrom = pick("X", DEFAULT_X_FROM);

            if (el.__secview_inited) return;
            el.__secview_inited = true;

            const fromVars = containerTween
                ? {
                    autoAlpha: 0,
                    x: xFrom,
                    filter: `blur(${blurFrom})`,
                }
                : {
                    autoAlpha: 0,
                    y: yFrom,
                    filter: `blur(${blurFrom})`,
                };

            const toVars = containerTween
                ? {
                    autoAlpha: 1,
                    x: "0%",
                    filter: "blur(0px)",
                    duration,
                    delay,
                    ease,
                    paused: true,
                    onComplete: () => {
                        gsap.set(el, { clearProps: "transform,filter" });
                        window.__SECVIEW_REFRESH_SCHEDULE__();
                    },
                }
                : {
                    autoAlpha: 1,
                    y: "0%",
                    filter: "blur(0px)",
                    duration,
                    delay,
                    ease,
                    paused: true,
                    onComplete: () => {
                        gsap.set(el, { clearProps: "transform,filter" });
                        window.__SECVIEW_REFRESH_SCHEDULE__();
                    },
                };

            const tween = gsap.fromTo(el, fromVars, toVars);

            const stOptions = {
                id: `secview-${containerTween ? "h" : "v"}-${idx}`,
                trigger: el,
                start,
                once,
                invalidateOnRefresh: true,
                onEnter: () => tween.restart(true),
                onEnterBack: () => tween.restart(true),
                onLeaveBack: () => {
                    if (!once) {
                        tween.pause(0);

                        if (containerTween) {
                            gsap.set(el, {
                                autoAlpha: 0,
                                x: xFrom,
                                filter: `blur(${blurFrom})`,
                            });
                        } else {
                            gsap.set(el, {
                                autoAlpha: 0,
                                y: yFrom,
                                filter: `blur(${blurFrom})`,
                            });
                        }

                        window.__SECVIEW_REFRESH_SCHEDULE__();
                    }
                },
            };

            if (containerTween) {
                stOptions.containerAnimation = containerTween;
                stOptions.start = pick("Start", "left 85%");
                stOptions.end = pick("End", "right left");
            }

            const st = ScrollTrigger.create(stOptions);

            if (st && (st.isActive || st.progress > 0)) {
                tween.restart(true);
            }
        });

        ScrollTrigger.refresh();
    }

  

    


}
